var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 16,
    viewBox: "0 0 49 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3416 5.09605C25.3137 7.31601 27.306 8.55475 28.8068 9.29133C30.3488 10.047 30.8667 10.5316 30.8606 11.2075C30.8491 12.2417 29.6306 12.6982 28.4904 12.7159C26.5012 12.7469 25.3445 12.175 24.425 11.7424L23.7083 15.1196C24.6309 15.5477 26.3392 15.9211 28.1107 15.9375C32.269 15.9375 34.9894 13.8702 35.0042 10.665C35.0205 6.59716 29.4174 6.37201 29.4557 4.55379C29.4689 4.00246 29.9913 3.41413 31.1359 3.26454C31.7024 3.18897 33.2664 3.13114 35.0396 3.9535L35.7355 0.686031C34.782 0.336345 33.5564 0.00150108 32.0305 0.00150108C28.1166 0.00150108 25.3638 2.09692 25.3416 5.09605ZM42.4229 0.282947C41.6636 0.282947 41.0237 0.729018 40.7381 1.41355L34.7982 15.6975H38.9535L39.7803 13.396H44.858L45.3376 15.6975H49L45.8041 0.282947H42.4229ZM43.0042 4.44699L44.2034 10.2353H40.9192L43.0042 4.44699ZM20.3036 0.283139L17.0283 15.6973H20.9879L24.2617 0.282754H20.3036M14.446 0.282754L10.3246 10.7747L8.6575 1.85384C8.46188 0.857983 7.68936 0.282947 6.83148 0.282947H0.0943633L0 0.73056C1.3831 1.03283 2.95455 1.52034 3.9066 2.04198C4.48924 2.36063 4.65538 2.63919 4.84679 3.39639L8.00442 15.6975H12.1888L18.6039 0.282947L14.446 0.282754Z",
    fill: "url(#paint0_linear_1015_7007)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1015_7007",
    x1: 22.5273,
    y1: 16.2572,
    x2: 22.9918,
    y2: -0.109142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visa_icon.7204b391283fdfc19a782a63224c9e65.svg";
export { ForwardRef as ReactComponent };